import React from 'react';
import RequestForm from './RequestForm/RequestForm';
const Connect = (props) => (
    <div className="main-content">
        <div className="container">
                <h2>{props.title}</h2>
                <div className="connect-image"></div>
                <RequestForm/>
                <div>
                     {/* <div className="connect-thumbnail-1"></div>
                     <div className="connect-thumbnail-2"></div> */}
                </div>     
                
        </div>
    </div>
    
);

export default Connect;